import { render, staticRenderFns } from "./documents-card.vue?vue&type=template&id=8cf526a0&lang=html&"
import script from "./documents-card.vue?vue&type=script&lang=js&"
export * from "./documents-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports